export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceAppliedContentsDetails: {
        serviceContentsId: 1,
        serviceContentsUuid: 'servicecontents001',
        deviceType: "hoambox",
        deliberyToKbn: 2,
        deliveryToLocationUuid: 'locations001',
        deliveryToAttributeGroupUuids: [
          'attributegroup001',
          'attributegroup008',
        ],
        contentsSnapshot: {
          contentsSnapshotId: 123,
          contentsSnapshotUuid: "snapshot001",
          snapshotName: "サービスコンテンツスナップショット名",
          snapshotTag: "サービスコンテンツスナップショットタグ",
          versionName: "バージョンネーム",
          releaseNote: "リリースノート",
          snapshotCreatedAt: 1234567890123
        }
      }
    }
  }
}